import styled from 'styled-components'

import { media } from '../../../utils/style-utils'
import { Item } from '../../Containers/Main/Item'

export default styled(Item)`
  position: relative;
  height: 300px;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  user-select: none;

  &:hover .arrow-icon {
    display: inline-block;
  }

  ${media.xxl`
    height: 250px;
  `}

  ${media.xl`
    height: 200px;
  `}

  ${media.lg`
    margin-bottom: 0;
  `}

  ${media.sm`
    height: 160px;
  `}
`
